import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import Chevron from 'static/images/sidebar/chevron-up.svg';
import { getResourceTo } from 'react/utils/utils';
import EconomyTruckItem from './economyTruckItem';
import { 
  getEconomyTruckData,
  economyTruckPeriodList,
  economyTruckList
} from './miniDashboarUtils';
import { DefaultRequest } from 'scripts/api';

function MiniDashboard({
  miniDashboardIsOpen,
  toggleDashboard
}) {
  const WEEK_INDEX = 1;
  const [selectedEconomyTruck, setSelectedEconomyTruck] = useState(economyTruckPeriodList[WEEK_INDEX]);
  const [economyTruckListData, setEconomyTruckListData] = useState({
    serviceTimeCompliance: getResourceTo('greenmile.minidashboard.notavailable'),
    mileageCompliance: getResourceTo('greenmile.minidashboard.notavailable'),
    costPerformance: getResourceTo('greenmile.minidashboard.notavailable'),
    smartGeocodeCorrections: getResourceTo('greenmile.minidashboard.notavailable'),
    timeWindowCompliance: getResourceTo('greenmile.minidashboard.notavailable'),
    stopServiceCompliance: getResourceTo('greenmile.minidashboard.notavailable'),
  });

  function handleToggleEconomyTruck(value) {
    setSelectedEconomyTruck(value);
  }

  useEffect(() => {
    new DefaultRequest({
      url: `/OrganizationSummary/Summarize?period=${selectedEconomyTruck.period}`,
      method: 'GET',
      success: (response) => {
        setEconomyTruckListData(getEconomyTruckData(response));
      }
    }).send();
  }, [selectedEconomyTruck])

  return (
    <>
      <div 
        data-testid="mini-dashboard"
        className={!miniDashboardIsOpen ? 'miniDashboardContainer' : 'miniDashboardContainer isOpen' }
      >
        <div className="scrollable-container">
          <div className="performance-summary">
            <h4>{getResourceTo('suspenseActions.miniDashboard.performanceSummary.title')}</h4>
            <div className="summary-container">
              {economyTruckPeriodList.map((item, index) => (
                <div 
                  data-testid={item.id}
                  key={index}
                  id={item.id} 
                  data-resource={item.resource} 
                  data-period={item.period}
                  enabled={selectedEconomyTruck.id === item.id ? 'true' : 'false'}
                  onClick={() => handleToggleEconomyTruck(item)}
                />
              ))}
              <div
                data-testid="economy-truck-text" 
                id="GreenmileEconomyText"
              >
                {getResourceTo(selectedEconomyTruck.resource)}
              </div>
            </div>
          </div>
          {economyTruckList.map(item => (
            <EconomyTruckItem 
              key={item.name}
              testid={item.name}
              content={economyTruckListData[item.name]}
              title={getResourceTo(item.title)}
              className={item.className}
            />
          ))}
        </div>
      </div>
      <div 
        onClick={toggleDashboard}
        className={!miniDashboardIsOpen ? 'miniDashboardIcon' : 'miniDashboardIcon dashboardIsOpen'}
      >
        <img src={Chevron} alt="Chevron Icon" />
      </div>
    </>
  );
}

MiniDashboard.propTypes = {
  miniDashboardIsOpen: PropTypes.bool.isRequired,
  toggleDashboard: PropTypes.func.isRequired,
};

export default MiniDashboard;